import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import './Login.css';
import { authApi } from './services/authApi';
import useUserStore from './store/userStore';
import { useLang } from './i18n/context';
import BrandMark from './components/BrandMark';

function Login() {
  const navigate = useNavigate();
  const { t } = useLang();
  const loginAction = useUserStore(state => state.login);
  const [emailError, setEmailError] = useState('');
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [submitting, setSubmitting] = useState(false);

  const validateEmail = (value) => /^[^@\s]+@[^@\s]+\.[^@\s]+$/.test(value);

  const handleEmailBlur = () => {
    if (email && !validateEmail(email)) setEmailError(t('login.validEmail'));
    else setEmailError('');
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!email || !password) { alert(t('login.fillAll')); return; }
    if (email && !validateEmail(email)) { alert(t('login.invalidEmail')); return; }

    try {
      setSubmitting(true);
      const data = await authApi.login({ email, password });
      loginAction(data.token, data.user);
      navigate('/');
    } catch (err) {
      console.error('登录失败:', err);
      alert(t('login.loginFailed') + '：' + (err?.message || t('login.retryLater')));
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <div className="auth-form">
      <div className="auth-logo">
        <BrandMark className="auth-logo-mark" />
        GHOST
      </div>

      <h1 className="auth-title">{t('login.title')}</h1>
      <p className="auth-subtitle">{t('login.passwordPlaceholder')}</p>

      <form className="auth-card" onSubmit={handleSubmit}>
        <input
          type="text"
          placeholder={t('login.emailPlaceholder')}
          value={email}
          onChange={e => setEmail(e.target.value)}
          onBlur={handleEmailBlur}
          className={emailError ? 'input-error' : ''}
        />
        {emailError && <div className="input-error-text">{emailError}</div>}
        <input
          type="password"
          placeholder={t('login.passwordPlaceholder')}
          value={password}
          onChange={e => setPassword(e.target.value)}
        />
        <button type="submit" className="auth-submit" disabled={submitting}>
          {submitting ? t('login.submitting') : t('login.submit')}
        </button>
      </form>

      <div className="auth-footer">
        <button className="auth-link" onClick={() => navigate('/register')}>{t('login.register')}</button>
        <span>·</span>
        <button className="auth-link" onClick={() => navigate('/forgot')}>{t('login.forgotPassword')}</button>
      </div>
    </div>
  );
}

export default Login;
